import { Component, OnInit } from '@angular/core';
import { NGXLogger } from 'ngx-logger';
import { Subscription } from 'rxjs/Subscription';
import { PaymentService } from '../../payment/Payment.Services';
import { TranslateService } from '@ngx-translate/core';
import { SharedService } from '../../shared/shared.service';
import { Router, ActivatedRoute } from '@angular/router';
import {MatDialog, MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {DonationInfo, DonationResponse} from "./donation-request";
import {DonationService} from "../../payment/Donation.Services";
import {DirectiveResolver} from "@angular/compiler";
declare var CryptoJS: any;
declare var AesUtil: any;
@Component({
  selector: 'donation',
  templateUrl: './donation.component.html',
  styleUrls: ['./donation.component.css']
})
export class DonationComponent implements OnInit {
  lan: string;
  subscription: Subscription;
  constructor(private logger: NGXLogger, private payService: PaymentService,
    private translate: TranslateService, private sharedService: SharedService, private router: Router,
    private activatedRoute: ActivatedRoute, private donationService: DonationService) {
  }
  lang: string;
  url: any;

  donationInf : DonationInfo;
  donationResp : DonationResponse;
  isSeries: boolean = false;
  isanonymous: boolean = false;
  ture: any;

  ngOnInit() {
    this.sharedService.refreshData();

    window.scroll(0, 0);
    this.lang = localStorage.getItem("lang");
    this.logger.debug('language is >>>>>>>>>>>' + this.lang);

    if (this.lang == "") {
      this.translate.use("ba");
      localStorage.setItem("lang", "ba");
    } else {
      this.translate.use(this.lang);
      localStorage.setItem("lang", this.lang);
    }

    this.donationInf = new DonationInfo();
  }

  checkMobileStartingDigit(mobileNo) {
    if (mobileNo.substring(1, 3) == 11 || mobileNo.substring(1, 3) == 13 ||  mobileNo.substring(1, 3) == 14
      || mobileNo.substring(1, 3) == 15 || mobileNo.substring(1, 3) == 16
      || mobileNo.substring(1, 3) == 17 || mobileNo.substring(1, 3) == 18 || mobileNo.substring(1, 3) == 19) {
      this.isSeries = false;
    } else if (mobileNo.length > 0) {
      this.isSeries = true;
    } else {
      this.isSeries = false;
    }
  }


  submitDonation() {
    this.donationInf.fund_code = 'f0011';
    console.log(this.donationInf)
    if(this.isanonymous){
      this.donationInf.cust_name = 'Anonymous Donor';
    }
    this.donationService.initiate(this.donationInf).subscribe(response => {
      this.donationResp = response.body;
      console.log(response)
      console.log(this.donationResp)
      if(this.donationResp.resp_code == '0000'){
        window.location.href = response.body.redirect_url
      }
      else{
        this.router.navigate(['/info'])
      }
    })
  }

  checkboxChange(event){
    if (event.target.checked) {
      this.isanonymous = true;
      this.donationInf.cust_name = "";
      this.donationInf.cust_occupation = "";
      this.donationInf.cust_email = "";
      this.donationInf.digi_center_name = "";
      this.donationInf.district = "";
    } else {
      this.isanonymous = false;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/donation/donation-info/donation.component.ts